/** @format */

export function OptionsTopics(customTopics) {
  const customTopicsArray = customTopics?.map((topic) => {
    return {
      value: topic.value,
      label: topic.label,
      color: topic.color,
    };
  });
  return [...customTopicsArray];
}
